<template>
  <div class="doc">
    <div class="row">
      <div class="col-2">
        <b-list-group>
          <b-list-group-item to="/help/search-orders">订单搜索</b-list-group-item>
          <b-list-group-item to="/help/manage-orders">订单管理</b-list-group-item>
          <b-list-group-item to="/help/tasks">打印任务</b-list-group-item>
          <b-list-group-item to="/help/send-orders">如何发货</b-list-group-item>
          <b-list-group-item to="/help/finance">财务相关</b-list-group-item>
          <b-list-group-item to="/help/other">其他</b-list-group-item>
        </b-list-group>
      </div>
      
      <div class="col-10">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help',
  components: {
    'vue-markdown': VueMarkdown
  }
}

</script>